export const TIME_SERIES_VISUALIZATION = 'time_series_visualization'
export const MODIFY_SETTING_COLUMN_RETURN_ID = 'modified_setting_value'
